<template>
  <div>
    <Card>
      <h2 class="header-title">信息填报</h2>
      <Divider></Divider>
      <Form ref="InformationFrom" :rules="InformationFromRules" :model="InformationFrom" :label-width="120">
        <Row :gutter="16">
          <Col :span="18" :offset="4">
            <Card dis-hover :bordered="false">
              <Row>
                <Col>
                  <FormItem label="事件名称" prop="eventTitle">
                    <Input v-model="InformationFrom.eventTitle" placeholder="事件名称"
                           @on-change="smsContentChange()"></Input>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormItem label="接报时间" prop="eventReceptionTime">
                    <DatePicker transfer v-model="InformationFrom.eventReceptionTime" type="datetime"
                                @on-change="smsContentChange()"
                                placeholder="选择接报时间"></DatePicker>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormItem label="上报人" prop="reportPerson">
                    <Input v-model="InformationFrom.reportPerson" placeholder="上报人"></Input>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormItem label="上报人电话" prop="reportPhone">
                    <Input v-model="InformationFrom.reportPhone" placeholder="上报人电话"></Input>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormItem label="信息类型" prop="isDrill">
                    <RadioGroup v-model="InformationFrom.isDrill" @on-change="getDutyTypeList">
                      <Radio :label="1">应急</Radio>
                      <Radio :label="0">路网</Radio>
                    </RadioGroup>
                  </FormItem>
                </Col>
              </Row>
              <div v-if="InformationFrom.isDrill===0">
                <Row>
                  <Col>
                    <FormItem label="事件类型" prop="eventType">
                      <Select transfer v-model="InformationFrom.eventType" placeholder="请选择事件类型"
                              @on-change="getEventCategorysList()">
                        <Option v-for="(item,index) in DutyTypeList" :key="index" :value="item.id">{{
                            item.name
                          }}
                        </Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormItem label="事件类别" prop="eventProperties">
                      <Select v-model="InformationFrom.eventProperties">
                        <Option v-for="(item,index) in EventCategorysList" :key="index" :label="item.name"
                                :value="item.id"></Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
              </div>
              <div v-if="InformationFrom.isDrill===1">
                <Row>
                  <Col>
                    <FormItem label="事件类型" prop="eventType">
                      <Select transfer v-model="InformationFrom.eventType" placeholder="请选择事件类型"
                              @on-change="getEventCategorysList()">
                        <Option v-for="(item,index) in DutyTypeList" :key="index" :value="item.id">{{
                            item.name
                          }}
                        </Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
              </div>
              <Row>
                <Col>
                  <FormItem label="事件发生区域" prop="eventDeptIndexCode">
                    <!--                  <Input v-model="InformationFrom.incidentArea" type="textarea" placeholder="事件区域"></Input>-->
                    <Select transfer v-model="InformationFrom.eventDeptIndexCode" clearable @on-change="getNoticeGroup"
                            :disabled="indexCodeFlag">
                      <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row :gutter="8">
                <Col :span="21">
                  <FormItem label="事件发生地点" prop="incidentArea">
                    <Input v-model="InformationFrom.incidentArea" placeholder="事件发生地点"
                           @on-change="smsContentChange"></Input>
                  </FormItem>
                </Col>
                <Col :span="3">
                  <Button type="primary" @click="openMapToLocal">定位</Button>
                </Col>
              </Row>
              <Row>
                <Col :span="12">
                  <FormItem label="经度" prop="longitude">
                    <Input v-model="InformationFrom.longitude" placeholder="经度"></Input>
                  </FormItem>
                </Col>
                <Col :span="12">
                  <FormItem label="纬度" prop="latitude">
                    <Input v-model="InformationFrom.latitude" placeholder="纬度"></Input>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormItem label="事件简述" prop="eventDescription">
                    <Input maxlength="300" show-word-limit type="textarea" v-model="InformationFrom.eventDescription"
                           placeholder="事件简述"></Input>
                  </FormItem>
                </Col>
              </Row>
              <!--              <Row v-if="curRole === '县中心管理人员'">-->
              <!--                <Col>-->
              <!--                  <FormItem label="严重程度" prop="eventSeverity">-->
              <!--                    <Select transfer clearable v-model="InformationFrom.eventSeverity" @on-change="getEventLevel">-->
              <!--                      <Option v-for="(item,index) in eventSeveritysList" :key="index" :label="item.name"-->
              <!--                              :value="item.id"></Option>-->
              <!--                    </Select>-->
              <!--                  </FormItem>-->
              <!--                </Col>-->
              <!--              </Row>-->
              <!--              <Row v-if="curRole === '县中心管理人员'">-->
              <!--                <Col>-->
              <!--                  <FormItem label="事件等级" prop="eventLevel">-->
              <!--                    <Select transfer clearable v-model="InformationFrom.eventLevel" placeholder="请选择事件等级">-->
              <!--                      <Option v-for="(item,index) in DutyLevelList" :key="index" :value="item.id">{{-->
              <!--                          item.name-->
              <!--                        }}-->
              <!--                      </Option>-->
              <!--                    </Select>-->
              <!--                  </FormItem>-->
              <!--                </Col>-->
              <!--              </Row>-->


              <Row>
                <Col>
                  <FormItem label="是否发送短信" prop="isSendSms">
                    <el-switch
                      v-model="InformationFrom.isSendSms"
                      active-color="#13ce66"
                      @change="isSendSmsChange"
                      inactive-color="#ff4949">
                    </el-switch>
                  </FormItem>
                </Col>
              </Row>
              <Row v-if="InformationFrom.isSendSms">
                <Col>
                  <FormItem label="短信内容">
                    <Input type="textarea" v-model="InformationFrom.smsContent"></Input>
                  </FormItem>
                </Col>
              </Row>
              <Row v-if="InformationFrom.isSendSms">
                <Col>
                  <FormItem label="通知小组" prop="contacts">
                    <Select
                      transfer
                      v-model="InformationFrom.contacts"
                    >
                      <Option v-for="(option, index) in noticeGroupList" :value="option.id" :key="index">{{
                          option.name
                        }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row v-if="imgList&&imgList.length > 0">
                <Col>
                  <FormItem label="现场图片" prop="eventImgPath">
                    <div style="display: flex;flex-direction: row;flex-wrap: wrap;align-content: flex-start;">
                      <!--                      <img v-for="(item,index) in imgList" :src="item" :key="index" width="200" height="200"-->
                      <!--                           style="margin-right: 10px"  @click="previewPic(item)"/>-->
                      <el-image v-for="(item,index) in imgList" :key="index"
                                style="width: 200px; height: 200px;margin-top: 10px;margin-right: 10px;"
                                :src="item"
                                :preview-src-list="imgList">
                      </el-image>
                    </div>
                  </FormItem>
                </Col>
              </Row>
              <!--              <Row>-->
              <!--              <Col>-->
              <!--                <FormItem label="处置建议" prop="disposalSuggestions">-->
              <!--                  <Input type="textarea" v-model="InformationFrom.disposalSuggestions" placeholder="处置建议"></Input>-->
              <!--                </FormItem>-->
              <!--              </Col>-->
              <!--            </Row>-->
            </Card>
          </Col>
          <!--        <Col :span="12">-->
          <!--          <Card dis-hover>-->
          <!--            <p slot="title">-->
          <!--              <span>勾选紧急联系人</span>-->
          <!--            </p>-->
          <!--            <div slot="extra">-->
          <!--              <Row :gutter="12">-->
          <!--                <Col :span="12">-->
          <!--                  <Button type="primary" size="small" @click="addTemporaryModalShow">添加临时人员</Button>-->
          <!--                </Col>-->
          <!--                <Col :span="12">-->
          <!--                  <Button type="primary" size="small" @click="addAddressBookModalShow">调取通讯录</Button>-->
          <!--                </Col>-->
          <!--              </Row>-->
          <!--            </div>-->
          <!--            <FormItem label="联系人">-->
          <!--              <Card dis-hover>-->
          <!--                <Tag v-for="(item,index) in TemporaryList" :key="index" size="large" closable-->
          <!--                     @on-close="delTemporary(index)">{{-->
          <!--                    item.name-->
          <!--                  }}-->
          <!--                </Tag>-->
          <!--              </Card>-->
          <!--            </FormItem>-->
          <!--            <FormItem label="其他" prop="other">-->
          <!--              <Input type="textarea" v-model="InformationFrom.other" placeholder="其他"></Input>-->
          <!--            </FormItem>-->
          <!--            <FormItem label="发送短信" prop="sendingMethod">-->
          <!--              <el-switch v-model="InformationFrom.sendingMethod"></el-switch>-->
          <!--            </FormItem>-->
          <!--            -->
          <!--          </Card>-->
          <!--        </Col>-->
        </Row>
        <!--      <Row style="margin-top: 30px">-->
        <!--        <Col :span="2" :offset="8" v-if="!InformationFrom.id">-->
        <!--          <Button type="primary" @click="submitNewInformation" :loading="submitNewInformationLoading">提交-->
        <!--          </Button>-->
        <!--        </Col>-->
        <!--        <Col :span="2" :offset="2" v-if="InformationFrom.id">-->
        <!--          <Button type="primary" @click="updateInformation" :loading="submitNewInformationLoading">更新-->
        <!--          </Button>-->
        <!--        </Col>-->
        <!--        <Col :span="2" :offset="2">-->
        <!--          <Button @click="cancelNewInformation">取消</Button>-->
        <!--        </Col>-->
        <!--      </Row>-->
        <div style="text-align: center;margin-top: 0px">
          <Button type="primary" v-if="!InformationFrom.id&&curRole === '市中心管理人员'"
                  @click="szxsubmitNewInformation"
                  :loading="submitNewInformationLoading">提交
          </Button>
          <Button type="primary" v-if="!InformationFrom.id&&curRole !== '市中心管理人员'" @click="submitNewInformation"
                  :loading="submitNewInformationLoading">提交
          </Button>
          <Button type="primary" v-if="InformationFrom.id&&curRole === '市中心管理人员'" @click="messageReceptions"
                  :loading="submitNewInformationLoading">更新
          </Button>
          <Button type="primary" v-if="InformationFrom.id&&curRole !== '市中心管理人员'" @click="updateInformation"
                  :loading="submitNewInformationLoading">更新
          </Button>
          <Button type="error" v-if="!InformationFrom.id" @click="cancelNewInformation"
                  style="margin-left: 20px">重置
          </Button>
          <Button type="primary" v-if="InformationFrom.id" style="margin-left: 20px" @click="openErrorEvent">误报
          </Button>
          <Button style="margin-left: 20px" @click="back">返回</Button>
        </div>
      </Form>
    </Card>
    <Modal
      v-model="errorModal"
      title="误报">
      <Row>
        <Col :span="4"><span style="text-align: right">误报原因</span></Col>
        <Col :span="20">
          <Input v-model="errorMessage" type="textarea" :autosize="{minRows: 2}" placeholder="请输入误报原因"/>
        </Col>
      </Row>
      <template #footer>
        <Button type="primary" @click="handleErrorEvent" :loading="errorLoading">提交</Button>
      </template>
    </Modal>
    <Modal v-model="addAddressBookModalIsShow"
           title="通讯录">
      <AddAddressBookModal ref="AddTemporaryModal"
                           :addTemporaryModalIsShow="addTemporaryModalIsShow"></AddAddressBookModal>
      <div slot="footer">
        <Button @click="addTemporaryModalIsShow = false">取消</Button>
        <Button type="primary" @click="addTemporary">确定</Button>
      </div>
    </Modal>
    <Modal v-model="addTemporaryModalIsShow"
           title="添加临时人员">
      <AddTemporaryModal ref="AddTemporaryModal" :addTemporaryModalIsShow="addTemporaryModalIsShow"></AddTemporaryModal>
      <div slot="footer">
        <Button @click="addTemporaryModalIsShow = false">取消</Button>
        <Button type="primary" @click="addTemporary">确定</Button>
      </div>
    </Modal>

    <Modal
      v-model="mapModal"
      title="地图"
      :width="800"
      @on-ok="ok"
      @on-cancel="cancel">
      <div style="margin-bottom: 10px">
        <el-autocomplete
          style="width:500px;"
          popper-class="autoAddressClass"
          size="medium"
          v-model="tosearchPlace"
          :fetch-suggestions="querySearchAsync"
          :trigger-on-focus="false"
          placeholder="详细地址"
          @select="handleSelect"
          clearable>
          <template slot-scope="{ item }">
            <div style="overflow:hidden;">
              <span>{{ item.address }}（{{ item.title }}）</span>
            </div>
          </template>
        </el-autocomplete>
        <!--        <Select-->
        <!--            v-model="tosearchPlace"-->
        <!--            filterable-->
        <!--            :remote-method="remoteMethod"-->
        <!--            @on-select="handleSelect"-->
        <!--            @on-change="handleChange"-->
        <!--            :loading="placeLoading"-->
        <!--            style="width: 500px"-->
        <!--        >-->
        <!--          <Option v-for="(option, index) in searchList" :value="option.value" :key="index">-->
        <!--            {{ option.label }}-->
        <!--          </Option>-->
        <!--        </Select>-->
        <!--        <AutoComplete-->
        <!--            transfer-->
        <!--            clearable-->
        <!--            v-model="tosearchPlace"-->
        <!--            @on-search="handleSearch"-->
        <!--            @on-select="handleSelect"-->
        <!--            placeholder="请输入搜索地址"-->
        <!--            style="width:600px">-->
        <!--          <Option v-for="item in searchList" :value="JSON.stringify(item)" :key="item.uid">{{-->
        <!--              item.address-->
        <!--            }}{{ item.title }}-->
        <!--          </Option>-->
        <!--        </AutoComplete>-->
        <Button type="primary" @click="getLocal" style="margin-left: 8px">搜索</Button>
      </div>
      <!--      {{ longitude }} {{ latitude }}-->
      <span>地址：{{ incidentArea }}</span>
      <div id="map" style="width: 100%;height: 400px"></div>
    </Modal>
  </div>
</template>

<script>
import AddTemporaryModal
  from "@/views/Duty/InformationReceiving/createAndEditNewInformation/components/addTemporaryModal";
import AddAddressBookModal
  from "@/views/Duty/InformationReceiving/createAndEditNewInformation/components/addAddressBookModal";
import {BMapLoader} from '@/utils/mapLoader'
import moment from "moment";

export default {
  name: "createAndEditNewInformation",
  components: {
    AddTemporaryModal,
    AddAddressBookModal
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (!/^1[3456789]\d{9}$/.test(value)) { // 判断用户输入的值是否符合规则
        callback(new Error('请输入正确的11位手机号码'))
      } else {
        callback()
      }
    }
    return {
      eType: 1,
      errorModal: false,
      errorMessage: '',
      errorLoading: false,
      showPic: false,
      selectPic: {},
      imgList: [],
      longitude: '',// 经度
      latitude: '',// 纬度
      incidentArea: '',
      tosearchPlace: '',
      placeLoading: false,
      searchList: [],
      countryList: [],
      noticeGroupList: [],//通知小组列表
      defaultSelect: [],//默认选择全部小组
      eventSeveritysList: [],
      EventCategorysList: [], // 事件类别列表
      mapModal: false,
      submitNewInformationLoading: false, // 提交新信息按钮loading
      TemporaryList: [], // 临时人员列表
      eventPropertiesList: [], // 事件属性列表
      addTemporaryModalIsShow: false, // 添加临时人员弹窗
      addAddressBookModalIsShow: false, // 调取通讯录弹窗
      DutyLevelList: [], // 事件等级列表
      DutyTypeList: [], // 事件类型列表
      InformationFromRules: {
        isDrill: [
          {required: true, message: '必填', trigger: 'change', type: 'any'}
        ], // 类型
        eventTitle: [
          {required: true, message: '必填', trigger: 'blur'}
        ], // 信息标题
        eventReceptionTime: [
          {required: true, type: 'date', message: '必填', trigger: 'blur'}
        ],  // 接报时间
        reportPerson: [
          {required: true, message: '必填', trigger: 'blur'}
        ], // 上报人
        eventProperties: [
          {required: true, message: '必填', trigger: 'blur'}
        ], // 事件属性
        eventType: [
          {required: true, message: '必填', trigger: 'change'}
        ], // 事件类型
        longitude: [
          {transform: (value) => String(value), required: true, message: '必填', trigger: 'blur'}
        ], // 经度
        latitude: [
          {transform: (value) => String(value), required: true, message: '必填', trigger: 'blur'}
        ], // 纬度
        eventDeptIndexCode: [
          {required: true, message: '必填', trigger: 'blur'}
        ], //事件发生区域区县id
        contacts: [
          {transform: (value) => String(value), required: true, message: '必填', trigger: 'blur'}
        ], //通知小组
        incidentArea: [
          {required: true, message: '必填', trigger: 'blur'}
        ], // 事件区域
        eventDescription: [
          {required: true, message: '必填', trigger: 'blur'}
        ], // 事件简述
        eventSeverity: [
          {required: true, message: '必填', trigger: 'blur'}
        ], //事件严重程度
        eventLevel: [
          {required: true, message: '必填', trigger: 'blur'}
        ], // 事件等级
        reportPhone: [
          {required: false, validator: validatePhone, trigger: 'change'}
        ]
      }, // 信息表单验证规则
      InformationFrom: {
        isSendSms: false, // 是否发送短信
        smsContent: '', // 短信内容
        isDrill: 0, // 0路网 1应急
        eventTitle: '', // 信息标题
        eventReceptionTime: '', // 接报时间
        reportPerson: '', // 上报人
        reportPhone: '',// 上报人电话
        eventProperties: '', // 事件类别
        eventType: '',// 事件类型
        longitude: '',// 经度
        latitude: '',// 纬度
        eventDeptIndexCode: null,//事件发生区域区县id
        contacts: null,//通知小组
        incidentArea: '',// 事件区域
        eventDescription: '',// 事件简述
        eventSeverity: null,//事件严重程度
        eventLevel: null,// 事件等级
        eventSituation: '',// 事件情况
        disposalSuggestions: '',// 处置建议
        other: '',// 其他
        sendingMethod: false// 发送方式
      },
      geocoder: '',
      curRole: '',
      indexCodeFlag: false
    }
  },
  created() {

  },
  mounted() {
    //debugger
    // if (this.$route.params.type) {
    //   // this.eType = this.$route.params.type
    //   this.InformationFrom.isDrill = this.$route.params.type
    // }
    this.$nextTick(() => {
      this.getDutyTypeList()
    })
    this.getEventPropertiesList()
    this.getCountry()
    this.getEventSeveritys()
    this.getUserData()
    if (this.$route.params.row) {
      this.indexCodeFlag = !!this.$route.params.row.cameraIndexCode;
      console.log('row', this.$route.params.row)
      if (this.$route.params.row.eventType) {
        this.$http.get(`/api/getEventCategorysList?typeId=${this.$route.params.row.eventType}`).then(res => {
          if (res.status === 200) {
            this.EventCategorysList = res.data
          }
        })
      }
      this.InformationFrom = this.$route.params.row
      if (this.$route.params.row.isDrill) {
        this.InformationFrom.isDrill = parseInt(this.$route.params.row.isDrill)
      } else {
        this.InformationFrom.isDrill = 1
      }
      if (this.$route.params.row.eventDeptIndexCode) {
        this.InformationFrom.eventDeptIndexCode = this.$route.params.row.eventDeptIndexCode
      } else {
        this.InformationFrom.eventDeptIndexCode = this.$route.params.row.deptIndexCode
      }
      this.getEventLevel(this.InformationFrom.eventSeverity)
    }
    if (this.InformationFrom.eventImgPath && this.InformationFrom.eventImgPath !== null) {
      this.imgList = this.InformationFrom.eventImgPath.split(';')
    }
    if (this.InformationFrom.eventDeptIndexCode !== null) {
      this.getNoticeGroup()
    }
    // this.initBMap()
  },
  methods: {
    // areaChange() {
    //   this.getNoticeGroup()
    //   this.smsContentChange()
    // },
    smsContentChange() {
      this.InformationFrom.smsContent = `在${moment(this.InformationFrom.eventReceptionTime).format('yyyy-MM-DD hh:mm')}，${this.InformationFrom.incidentArea}发生时间标题为${this.InformationFrom.eventTitle}的事件，请及时关注！`
    },
    isSendSmsChange(flag) {
      if (flag) {
        this.smsContentChange()
      }
    },
    // 获取短信内容
    getSmsContent() {
      let request = {
        eventReceptionTime: this.InformationFrom.eventReceptionTime,
        incidentArea: this.InformationFrom.incidentArea,
        eventTitle: this.InformationFrom.eventTitle,
      }
      this.$http.post(`/api/getMessageContent`, request).then(res => {
        if (res.status === 200) {
          this.InformationFrom.smsContent = res.data
        }
      })
    },
    // 获取类别
    getEventCategorysList() {
      this.$http.get(`/api/getEventCategorysList?typeId=${this.InformationFrom.eventType}`).then(res => {
        if (res.status === 200) {
          this.EventCategorysList = res.data
        }
      })
    },
    getUserData() {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.curRole = res.data.roleNames
        }
      })
    },
    openErrorEvent() {
      this.errorModal = true
    },
    //提交误报事件
    handleErrorEvent() {
      if (this.errorMessage === '') {
        this.$Message.warning('请填写原因！')
        return
      }
      this.errorLoading = true
      let params = {
        id: this.InformationFrom.id,
        other: this.errorMessage
      }
      this.$http.put('/api/handleErrorEvent', params).then(res => {
        // console.log(res)
        this.errorLoading = false
        if (res.status === 200) {
          this.errorModal = false
          this.$Message.success('提交成功！')
          // 跳转关闭当前页
          this.$store.commit('app/closePage', {
            vm: this,
            fromName: this.$route.name,
            toName: 'home'
          })
        }
      })
    },
    previewPic(item) {
      this.showPic = true
      this.selectPic = item
    },
    ok() {
      this.InformationFrom.latitude = this.latitude
      this.InformationFrom.longitude = this.longitude
      this.InformationFrom.incidentArea = this.incidentArea
      this.smsContentChange()
    },
    // 返回上一级
    back() {
      this.$router.go(-1)
    },
    cancel() {
    },
    //打开地图定位
    openMapToLocal() {
      // if (this.InformationFrom.incidentArea === '') {
      //   this.mapModal = false
      //   this.$Message.warning('请填写事件发生地点！')
      //   return
      // }
      this.mapModal = true
      this.tosearchPlace = ''
      this.initBMap()
    },
    initBMap() {
      var _this = this
      BMapLoader(this.$mapConfigKey).then(BMap => {
        const map = new BMap.Map('map', {enableMapClick: false})
        _this.map = map
        _this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        // const point = new BMap.Point(116.36555, 37.44131)
        // map.centerAndZoom('德州市', 16)
        // var marker = new BMap.Marker(point)
        // this.Map.addOverlay(marker);
        if (_this.InformationFrom.latitude !== '' && _this.InformationFrom.longitude !== '') {
          // this.setPlace()
          const point = new BMap.Point(_this.InformationFrom.longitude, _this.InformationFrom.latitude)
          map.centerAndZoom(point, 16)
          _this.handleMarker(_this, point)
        } else {
          map.centerAndZoom('德州市', 16)
        }
        //点击地图获取经纬度
        map.addEventListener("click", function (e) {
          // console.log(e)
          const point = e.latlng
          _this.handleMarker(_this, point)
        });
      })
    },
    setPlace() {
      this.local = new this.BMap.LocalSearch(this.map, {
        onSearchComplete: this.searchPlace
      });
      this.local.search(this.InformationFrom.incidentArea);
    },
    searchPlace() {
      if (this.local.getResults() != undefined) {
        this.map.clearOverlays(); //清除地图上所有覆盖物
        if (this.local.getResults().getPoi(0)) {
          let point = this.local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
          this.map.centerAndZoom(point, 16);
          this.handleMarker(this, point);
          console.log("经度：" + point.lng + "--" + "纬度" + point.lat);
          this.latitude = point.lat;
          this.longitude = point.lng;
        } else {
          this.$Message.error("未匹配到地点!");
        }
      } else {
        this.$Message.error("未找到搜索结果!");
      }
    },
    // 设置标注
    handleMarker(obj, point) {
      let that = this;
      that.map.clearOverlays(); //清除地图上所有覆盖物
      obj.mk = new that.BMap.Marker(point);
      obj.map.addOverlay(obj.mk);
      obj.mk.enableDragging(); // 可拖拽
      obj.mk.addEventListener("dragend", function (e) {
        // console.log(e)
        console.log("经度：" + e.latLng.lng + "--" + "纬度" + e.latLng.lat)
        // 监听标注的拖拽，获取拖拽后的经纬度
        that.latitude = e.latLng.lat;
        that.longitude = e.latLng.lng;
        that.getAddressBylatlng(e.latLng)
      });
      // obj.mk.addEventListener("click", function (e) {
      //   // console.log(e)
      //   console.log("经度：" + e.latLng.lng + "--" + "纬度" + e.latLng.lat)
      //   that.latitude = e.latLng.lat;
      //   that.longitude = e.latLng.lng;
      //   that.getAddressBylatlng(e.latLng)
      // });
      obj.map.panTo(point);
      that.getAddressBylatlng(point)
    },
    // 搜索地点
    handleSearch(str) {
      let _this = this
      _this.tosearchPlace = str
      // var options = {
      //   onSearchComplete: function (res) { //检索完成后的回调函数
      //     var s = [];
      //     console.log(local.getStatus())
      //     if (local.getStatus() === BMAP_STATUS_SUCCESS) {
      //       for (var i = 0; i < res.getCurrentNumPois(); i++) {
      //         s.push(res.getPoi(i));
      //       }
      //       // console.log(s)
      //       _this.searchList = s
      //     } else {
      //       _this.searchList = s
      //     }
      //     console.log(_this.searchList)
      //   }
      // }
      var local = new _this.BMap.LocalSearch(_this.map, {
        onSearchComplete: function (res) { //检索完成后的回调函数
          var s = [];
          console.log(local.getStatus())
          if (local.getStatus() === BMAP_STATUS_SUCCESS) {
            for (var i = 0; i < res.getCurrentNumPois(); i++) {
              s.push(res.getPoi(i));
            }
            // console.log(s)
            _this.searchList = s
          } else {
            _this.searchList = s
          }
          console.log(_this.searchList)
        }
      }) //创建LocalSearch构造函数
      local.search(str) //调用search方法，根据检索词str发起检索
    },
    handleSelect(item) {
      console.log(item)
      this.tosearchPlace = item.address + item.title
      this.local = item
    },
    handleChange(value) {
      console.log(value)
      const item = JSON.parse(value)
      this.local = item
      console.log(this.local)
      // this.tosearchPlace = item.address + item.title
    },
    getLocal() {
      console.log(this.tosearchPlace)
      // console.log(this.searchList)
      // this.local = this.searchList.filter(item => item.title === this.tosearchPlace)
      console.log(this.local)
      if (this.local) {
        //   for (var i = 0; i < this.local.length; i++) {
        var lat = this.local.point.lat // 经度
        var lng = this.local.point.lng // 纬度
        this.latitude = lat;
        this.longitude = lng;
        this.incidentArea = this.local.address + this.local.title
        var point = new this.BMap.Point(lng, lat)
        this.handleMarker(this, point)
        // var marker = new this.BMap.Marker(point)
        // this.map.addOverlay(marker);
        // this.map.centerAndZoom(point, 16)
        // }
      }
    },
    // 根据经纬度获取地址
    getAddressBylatlng(point) {
      console.log('poi', point)
      this.geocoder = new this.BMap.Geocoder(); //创建地址解析器的实例
      this.geocoder.getLocation(point, res => {
        console.log(res)
        // this.tosearchPlace = res.surroundingPois[0].address + res.surroundingPois[0].title;
        if (res.surroundingPois.length > 0) {
          this.incidentArea = res.surroundingPois[0].address + res.surroundingPois[0].title;
        } else {
          this.incidentArea = res.address
        }
        this.longitude = point.lng
        this.latitude = point.lat
        this.$forceUpdate();
      });
    },
    //严重程度
    getEventSeveritys() {
      this.$http.get('/api/eventSeveritys').then(res => {
        // console.log(res)
        this.eventSeveritysList = res.data.data
      })
    },
    getEventLevel(value) {
      console.log(value)
      let id = value
      if (id) {
        this.$http.get(`/api/getEventLevelList/${id}`).then(res => {
          // console.log(res)
          this.DutyLevelList = res.data
        })
      }
    },
    //区县
    getCountry() {
      this.$http.get('/api/getAllCountys').then(res => {
        // console.log(res)
        this.countryList = res.data
      })
    },
    // 根据区县获取通知小组
    getNoticeGroup() {
      this.$http.get(`/api/getNoticeGroupsList/${this.InformationFrom.eventDeptIndexCode}`).then(res => {
        console.log(res)
        this.noticeGroupList = res.data
        // this.InformationFrom.contacts = this.noticeGroupList.map(item => item.id)
      })
    },
    // 获取事件属性列表
    getEventPropertiesList() {
      this.eventPropertiesList = [
        {title: '安全生产', value: 1},
        {title: '二级', value: 2},
        {title: '三级', value: 3},
        {title: '四级', value: 4}]
      // this.$http.get(`/api/eventProperties`).then(res => {
      //   if (res.status === 200) {
      //     this.eventPropertiesList = res.data.data
      //   } else {
      //     this.$Message.error('获取事件属性列表失败')
      //   }
      // })
    },
    // 获取事件类型列表
    getDutyTypeList() {
      this.$http.get(`/api/getEventTypesListByType?type=${this.InformationFrom.isDrill}`).then(res => {
        if (res.status === 200) {
          this.DutyTypeList = res.data
        } else {
          this.$Message.error('获取事件类型列表失败')
        }
      })
    },
    // 添加临时人员弹窗
    addTemporaryModalShow() {
      this.addTemporaryModalIsShow = true
    },
    // 添加临时人员
    addTemporary() {
      let TemporaryObj = this.$refs.AddTemporaryModal.TemporaryFrom
      this.TemporaryList.push(TemporaryObj)
      this.addTemporaryModalIsShow = false
    },
    // 删除临时人员
    delTemporary(index) {
      this.TemporaryList.splice(index, 1)
    },
    addAddressBookModalShow() {
      this.addAddressBookModalIsShow = true
    },
    submitNewInformation() {
      console.log(this.InformationFrom)
      this.$refs.InformationFrom.validate((valid) => {
        if (valid) {
          // this.submitNewInformationLoading = true
          // const group = this.InformationFrom.contacts.toString()
          const group = this.InformationFrom.contacts === null ? '' : this.InformationFrom.contacts.toString()
          let requestData = {
            ...this.InformationFrom,
            contacts: group,
            sendingMethod: this.InformationFrom.sendingMethod ? 1 : 0,
            content: this.InformationFrom.isSendSms ? this.InformationFrom.smsContent : null,
            eventProperties: this.InformationFrom.eventProperties === '' ? null : this.InformationFrom.eventProperties,
            disposalSuggestions: this.InformationFrom.disposalSuggestions === '' ? null : this.InformationFrom.disposalSuggestions,
            eventSituation: this.InformationFrom.eventSituation === '' ? null : this.InformationFrom.eventSituation,
          }
          this.$http.post('/api/messageReceptions', requestData).then(res => {
            this.submitNewInformationLoading = false
            this.$Message.success('提交成功！')
            this.$refs.InformationFrom.resetFields()
            // 跳转关闭当前页
            this.$store.commit('app/closePage', {
              vm: this,
              fromName: this.$route.name,
              toName: 'home'
            })
          })
        } else {
          console.log('提交失败！')
          return false
        }
      })
    },
    //补充小程序事件上报
    updateInformation() {
      this.$refs.InformationFrom.validate((valid) => {
        if (valid) {
          this.submitNewInformationLoading = true
          console.log('呵呵')
          console.log(this.InformationFrom.contacts)
          const group = this.InformationFrom.contacts === null ? '' : this.InformationFrom.contacts.toString()
          console.log('到我这')
          let requestData = {
            ...this.InformationFrom,
            contacts: group,
            content: this.InformationFrom.isSendSms ? this.InformationFrom.smsContent : null
          }
          this.$http.put('/api/updateAppMessageReceptions', requestData).then(res => {
            this.submitNewInformationLoading = false
            this.$Message.success('更新成功')
            // this.$refs.InformationFrom.resetFields()
            // 跳转关闭当前页
            this.$store.commit('app/closePage', {
              vm: this,
              fromName: this.$route.name,
              toName: 'home'
            })
            console.log(res)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //市中心提交
    szxsubmitNewInformation() {
      console.log(this.InformationFrom)
      this.$refs.InformationFrom.validate((valid) => {
        if (valid) {
          this.submitNewInformationLoading = true
          let requestData = {
            ...this.InformationFrom,
            content: this.InformationFrom.isSendSms ? this.InformationFrom.smsContent : null
          }
          this.$http.post('/api/messageReceptions', requestData).then(res => {
            this.submitNewInformationLoading = false
            this.$Message.success('提交成功！')
            // this.$refs.InformationFrom.resetFields()
            this.$store.commit('app/closePage', {
              vm: this,
              fromName: this.$route.name,
              toName: 'home'
            })
          })
        } else {
          console.log('提交失败！')
          return false
        }
      })
    },
    //市中心补充事件发生区域上报
    messageReceptions() {
      this.$refs.InformationFrom.validate((valid) => {
        if (valid) {
          this.submitNewInformationLoading = true
          let requestData = {
            ...this.InformationFrom,
            content: this.InformationFrom.isSendSms ? this.InformationFrom.smsContent : null
          }
          this.$http.put('/api/messageReceptions', requestData).then(res => {
            this.submitNewInformationLoading = false
            this.$Message.success('更新成功')
            // this.$refs.InformationFrom.resetFields()
            // 跳转关闭当前页
            this.$store.commit('app/closePage', {
              vm: this,
              fromName: this.$route.name,
              toName: 'home'
            })
            console.log(res)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelNewInformation() {
      this.$refs.InformationFrom.resetFields()
    },
    setDefaultOptions(options) {
      this.InformationFrom.contacts = options
    },
    remoteMethod(query) {
      let _this = this
      if (query !== '') {
        _this.placeLoading = true;
        setTimeout(() => {
          _this.placeLoading = false;
          var local = new _this.BMap.LocalSearch(_this.map, {
            onSearchComplete: function (res) { //检索完成后的回调函数
              var s = [];
              // console.log(query, local.getStatus())
              if (local.getStatus() === BMAP_STATUS_SUCCESS) {
                for (var i = 0; i < res.getCurrentNumPois(); i++) {
                  s.push(res.getPoi(i));
                }
                // console.log(s)
                _this.searchList = s
              } else {
                _this.searchList = s
              }
              // console.log(_this.searchList)
              const list = _this.searchList.map(item => {
                return {
                  value: JSON.stringify(item),
                  label: (item.address + item.title).trim()
                };
              });
              _this.searchList = list
            }
          }) //创建LocalSearch构造函数
          local.search(query) //调用search方法，根据检索词str发起检索
        }, 500);
      } else {
        _this.searchList = [];
      }
    },
    querySearchAsync(str, cb) {
      setTimeout(() => {
        var options = {
          onSearchComplete: function (res) { //检索完成后的回调函数
            var s = [];
            if (local.getStatus() == BMAP_STATUS_SUCCESS) {
              for (var i = 0; i < res.getCurrentNumPois(); i++) {
                s.push(res.getPoi(i));
              }
              cb(s) //获取到数据时，通过回调函数cb返回到<el-autocomplete>组件中进行显示
            } else {
              cb(s)
            }
          }
        }
        var local = new this.BMap.LocalSearch(this.map, options) //创建LocalSearch构造函数
        local.search(str) //调用search方法，根据检索词str发起检索
      }, 500);
    }
  }
}
</script>

<style scoped lang="less">
@import "newInformation";
</style>
